<template>
  <q-dialog v-model="dialog" persistent class="order-quotation-dialog quotation-success-dialog">
    <q-card>
      <q-toolbar class="information">
        <q-avatar>
          <q-icon name="mdi-alert-circle" />
        </q-avatar>
        <q-toolbar-title class="text-weight-bold">お問い合わせ完了</q-toolbar-title>
      </q-toolbar>
      <q-card-section>
        <div class="q-mb-md order-num">
          <p class="order-title">お問い合わせ番号</p>
          <p>
            <span class="q-ml-md">{{ quotationNo }}</span>
          </p>
        </div>
        <p class="q-mb-sm">お問い合わせ内容をメールで送信いたしましたので、ご確認ください。</p>
        <p class="q-mb-xs">
          お問い合わせ完了メールが届かない場合は、メールの送受信に不具合がある可能性がございますので、<br />お手数ですが、お電話にて下記までお問い合わせください。<br />
        </p>
        <p class="q-mb-none">TEL: 03-6262-6467</p>
      </q-card-section>
      <q-card-actions align="center" class="btn-area">
        <q-btn color="primary" :label="btnName" style="width: 220px" @click="ok" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  // ダイアログを表示するかどうか
  display: boolean;
  // 問い合わせ番号
  quotationNo: string;
  // ボタン名
  btnName: string;
}

const props = defineProps<Props>();
const dialog = computed(() => props.display);

const emit = defineEmits<{
  (event: 'ok'): void;
}>();

const ok = () => {
  emit('ok');
};
</script>
<style scoped>
.order-num span {
  font-size: 1.2rem;
  letter-spacing: 1px;
}

.quotation-success-dialog .q-card {
  min-width: 400px;
  padding: 15px 30px;
}
.quotation-success-dialog .q-toolbar .q-avatar {
  font-size: 36px;
}

.quotation-success-dialog .q-toolbar.information .q-icon {
  color: var(--q-info);
  font-size: 34px;
}

.quotation-success-dialog .q-toolbar .q-toolbar__title {
  font-size: 22px;
  padding-top: 4px;
  line-height: 36px;
  padding-left: 14px;
}
</style>
